<template>
  <div class="list_card" @click="toDetail">
    <div class="zhuan_li_hao">{{ obj.projectCode }}</div>
    <div class="type">{{ dealWayFullDisplay }}</div>
    <div class="flex-between-left" style="margin-bottom: 5px;">
      <div style="width: 100%">
        <div class="biao_ti line" :style="`width:${obj.image ? '70%' : '100%'}`">
          {{ obj.title }}
        </div>
        <div class="jie_shao line" :style="`width:${obj.image ? '70%' : '100%'}`">
          {{ obj.projectBrief | stripHtml }}
        </div>
      </div>
      <div class="img flex-center" v-if="obj.image && obj.image.length > 2">
        <el-image fit="cover" style="width: 100%; height: 50px" :src="obj.image | getImgsOne">
        </el-image>
      </div>
    </div>
    <div class="biao_qian flex-left flex-wrap" v-if="displayLabels.length > 0">
      <div class="flex-center" :class="inde == 0 ? 'checked' : ''" v-for="(ite, inde) in displayLabels" :key="inde">
        {{ ite }}
      </div>
    </div>
    <div class="flex-between flex-wrap">
      <div class="ming_cheng flex-left-center">
        <span></span>
        <div class="line">{{ obj.userName }}</div>
      </div>
      <div class="jia_ge flex-end-center" v-if="displayPrice || displayPrice === 0">
        <!-- <span class="flex-center">折扣价</span> -->
        {{ displayCurrencyPrefix }} {{ displayPrice }}万元
      </div>
      <div class="jia_ge flex-end-center" v-else>面议</div>
    </div>
  </div>
</template>

<script>
import { getImgsOne, priceCurrencyPrefix, getListingDisplayPrice } from "../api/util";
export default {
  //过滤器
  filters: {
    getImgsOne(val) {
      return getImgsOne(val);
    },
    stripHtml(val) {
      if (!val) return "";
      const div = document.createElement("div");
      div.innerHTML = val;
      return div.textContent || div.innerText || "";
    },
  },
  methods: {
    // 跳转详情
    toDetail() {
      let data = `id=${this.obj.id}`;

      if (this.tj.length > 0) data += `&tj=${this.tj}`;

      this.$router.push(`/details?${data}`);
    },
  },
  created() {
    // console.warn(this.obj, '你好');
  },

  // 子组件接收
  props: {
    obj: {
      type: Object,
      default() {
        return {};
      },
    },
    tj: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    dealWayList() {
      if (!this.obj || !this.obj.dealWay) return [];
      const isFormalProject = this.obj.projType === 0 || this.obj.projType === "0";
      return [...new Set(String(this.obj.dealWay).split(",").filter(Boolean))].filter(
        (item) => !(isFormalProject && item === "许可")
      );
    },
    dealWayListRaw() {
      if (!this.obj || !this.obj.dealWay) return [];
      return [...new Set(String(this.obj.dealWay).split(",").filter(Boolean))];
    },
    dealWayDisplayItems() {
      const items = [...this.dealWayList];
      if (this.obj.licenseType) items.push(this.obj.licenseType);
      if (this.obj.licenseTypeCross) items.push("交叉许可");
      if (this.obj.licenseTypeFraction) items.push("分许可");
      if (this.dealWayList.includes("实施许可") && this.obj.permission) {
        items.push(this.obj.permission);
      }
      if (this.dealWayList.includes("其他") && this.obj.dealWayExtra) {
        items.push(this.obj.dealWayExtra);
      }
      return items;
    },
    dealWayFullDisplay() {
      const isFormalProject = this.obj.projType === 0 || this.obj.projType === "0";
      // return this.dealWayDisplayItems.join("，");
      return isFormalProject ? this.dealWayDisplayItems.join("，") : this.dealWayListRaw.join("，");
    },
    displayLabels() {
      const labels = this.obj.labels;
      if (!labels || !labels.length) return [];
      return labels.filter((l) => l !== "境内" && l !== "境外");
    },
    displayCurrencyPrefix() {
      const unit =
        this.obj.foreignType ||
        this.obj.floorPriceUnit ||
        this.obj.priceUnit ||
        this.obj.currency ||
        this.obj.currencyUnit ||
        (this.obj.done && (this.obj.done.foreignType || this.obj.done.floorPriceUnit)) ||
        (this.obj.markReleasePO &&
          (this.obj.markReleasePO.foreignType ||
            this.obj.markReleasePO.floorPriceUnit));
      return priceCurrencyPrefix(unit);
    },
    displayPrice() {
      if (this.obj.price || this.obj.price === 0) return this.obj.price;
      return getListingDisplayPrice(this.obj);
    },
  },
};
</script>

<style lang="scss">
.list_card:hover {
  transition: box-shadow 0.3s, border-color 0.3s;
  visibility: visible;
  box-shadow: 0px 0px 20px #ccc;
}

.list_card {
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #e5e6eb;
  width: 31%;
  padding: 16px 20px;
  margin-top: 24px;
  cursor: pointer;
  position: relative;

  .ming_cheng {
    font-size: 12px;
    font-weight: 400;
    color: #4e5969;
    width: 65%;

    &>div {
      width: 80%;
    }

    span {
      display: block;
      width: 24px;
      height: 24px;
      background: #f2f3f5;
      border-radius: 50%;
      margin-right: 8px;
    }
  }

  .jia_ge {
    font-size: 18px;
    font-weight: 500;
    color: #eb5757;

    span {
      display: inline-block;
      height: 20px;
      font-size: 12px;
      font-weight: 400;
      color: #eb5757;
      background: #ffece8;
      padding: 0 6px;
      margin-right: 8px;
    }
  }

  .biao_qian {
    font-size: 12px;
    font-weight: 400;
    color: #86909c;
    padding: 16px 0;
    margin-bottom: 18px;
    border-bottom: 1px solid #e5e6eb;

    &>div {
      height: 20px;
      background: #f2f3f5;
      border-radius: 2px 2px 2px 2px;
      padding: 0 6px;
      margin-right: 8px;
      margin-bottom: 3px;
    }

    .checked {
      color: #165dff;
      background: #e8f3ff;
    }
  }

  .zhuan_li_hao {
    font-size: 12px;
    font-weight: 400;
    color: #a9aeb8;
    margin-bottom: 16px;
  }

  .type {
    position: absolute;
    right: 20px;
    top: 15px;
    font-size: 14px;
  }

  .biao_ti {
    font-size: 18px;
    font-weight: 500;
    color: #1d2129;
    line-height: 28px;
  }

  .jie_shao {
    font-size: 12px;
    font-weight: 400;
    color: #86909c;
    line-height: 20px;
  }

  .img {
    width: 30%;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e5e6eb;
    margin-left: 10px;

    img {
      width: 100%;
      max-height: 100%;
    }
  }
}
</style>
